import React from 'react'
import * as Yup from 'yup'
import { Box } from '../../designSystem'
import {
  ForgetPasswordDiv,
  LoginDiv,
  LoginHeading,
  LoginSignupDiv,
  Signup,
  LoginButton,
} from './styles'
import { Formik, Form } from 'formik'
import { FloatingInput } from '../FormikInputs'
import { emailValidation, handleEventLog, saveSession } from '../../lib/utils'
import Loader from '../Loader'
import { get, post } from '../../lib/api'
import { menuItemObj } from '../../constants'

function Login({
  email,
  onLoginSignupClick,
  activationButton,
  type,
  message,
  onActivationClick,
  setActivationButton,
  setMessage,
  setEmail,
  changeView,
  onUpdateUser,
  history,
  setTempSessionInfo
}) {
  const referrer = localStorage.getItem('referrer')

  return (
    <>
      <LoginHeading>Enter your Details To Continue</LoginHeading>
      <Formik
        initialValues={{
          email: email,
          password: '',
        }}
        validationSchema={Yup.object({
          email: Yup.string().required('Required'),
          password: Yup.string().required('Required'),
        })}
        enableReinitialize
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true)
          handleEventLog(
            type === 'login' ? 'email_log_in' : 'email_sign_up',
            'button_click',
            { module_name: type === 'login' ? 'email_log_in' : 'email_sign_up' }
          )
          setActivationButton(false)
          setMessage({ ...message, text: '' })
          setEmail(values.email)
          const loginData = {
            type: 'email_login',
            email: values.email,
            password: values.password,
            view: 'dashboard',
            user_type: 'pugc',
            referrer: referrer,
            device_id: localStorage.getItem('uuid'),
          }
          setSubmitting(true)
          post(`/user_api/user.login?type=${type}&is_novel=1`, {
            data: loginData,
          })
            .then((response) => {
              setSubmitting(false)
              if (response.result) {
                const { user_info = {} } = response.result[0]
                const {
                  uid,
                  access_token: token,
                  image_url: userImageUrl,
                  fullname: userName,
                } = user_info
                const isUserExist = response.result[0].already_exists

                const sessionInfo = {
                  uid,
                  token,
                  image_url: userImageUrl,
                  name: userName,
                }
                if (typeof isUserExist == 'undefined' || isUserExist === 0) {
                  // dont save sessioninfo to localstorage yet, wait for the user to register
                  // if the user drops off at this point, no need to save userinfo to localstorage
                  // otherwise user will be directly logged in next time user opens studio and wont be able to select account type
                  changeView('register')
                  setMessage({ ...message, text: '' })
                  setTempSessionInfo(sessionInfo)
                  handleEventLog(
                    type === 'login' ? 'email_log_in' : 'email_sign_up',
                    type === 'login' ? 'login_fail' : 'signup_fail',
                    { uid, login_type: 'email' }
                  )
                } else if (isUserExist === 1) {
                  saveSession(sessionInfo)
                  handleEventLog(
                    type === 'login' ? 'email_log_in' : 'email_sign_up',
                    type === 'login' ? 'login_success' : 'signup_success',
                    { uid, login_type: 'email' }
                  )
                  get('/user_api/user.get_creator_details?is_novel=1').then(
                    (res) => {
                      onUpdateUser(res.result)
                      if (referrer?.includes('contest'))
                        window.location.href = `/shows/novels/?referrer=${referrer}&open-new=1`
                      else history.push(menuItemObj.home)
                    }
                  )
                }
              } else {
                setMessage({ text: response.message, color: 'green' })
              }
            })
            .catch((error) => {
              setSubmitting(false)
              setMessage({ ...message, text: error.message, color: 'red' })
              if (error.message?.includes('not verified')) {
                setActivationButton(true)
              }
            })
        }}
      >
        {({ values = {}, isSubmitting, errors, resetForm }) => (
          <Form>
            <Box mb={16}>
              <LoginSignupDiv>
                <Signup
                  type={type}
                  onClick={() => onLoginSignupClick('signup', resetForm)}
                >
                  Signup
                </Signup>
                <LoginDiv
                  type={type}
                  onClick={() => onLoginSignupClick('login', resetForm)}
                >
                  Login
                </LoginDiv>
              </LoginSignupDiv>
            </Box>
            <Box width="100%" mb={16}>
              <FloatingInput
                type="text"
                name="email"
                label="Email ID"
                size="lg"
              />
            </Box>
            <Box width="100%" mb={16}>
              <FloatingInput
                type="password"
                name="password"
                label="Password"
                size="lg"
                password
              />
            </Box>
            <Box mb={10}>
              <ForgetPasswordDiv onClick={() => changeView('forgetPassword')}>
                Forgot Password?
              </ForgetPasswordDiv>
            </Box>
            <Box width="100%" mb={16}>
              <LoginButton
                id="login-handler"
                disabled={!emailValidation(values.email) || errors.password}
                type="submit"
              >
                {isSubmitting ? (
                  <Loader size="sm" invertColor noPadding />
                ) : (
                  'continue'
                )}
              </LoginButton>
            </Box>

            {message.text !== '' && (
              <Box
                variant="flex"
                justifyContent="center"
                color={message.color === 'red' ? 'red' : 'green'}
              >
                {message.text}
              </Box>
            )}
          </Form>
        )}
      </Formik>
      {activationButton && (
        <Box mt={16}>
          <LoginButton type="notsubmit" onClick={() => onActivationClick()}>
            Resend Email Activation Link
          </LoginButton>
        </Box>
      )}
    </>
  )
}

export default Login
